export default "__VITE_ASSET__CEdqp3c5__"